import React, { useId, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ContactRound, Save, X } from 'lucide-react'
import { tr } from 'i18n'
import ActorPinField from 'components/Erp/ActorPinField/ActorPinField.tsx'
import s from '../Management.module.scss'

type Props = { name: string; currentInn: string; busy: boolean; error: string; onClose: () => void; onConfirm: (inn: string, pin: string) => void }

export default function OperatorInnDialog({ name, currentInn, busy, error, onClose, onConfirm }: Props) {
  useTranslation()
  const titleId = useId()
  const [inn, setInn] = useState(currentInn)
  const [pin, setPin] = useState('')
  const valid = /^[0-9]{14}$/.test(inn) && /^[0-9]{4}$/.test(pin)
  return <div className={s.overlay}>
    <form className={s.dialog} role="dialog" aria-modal="true" aria-labelledby={titleId}
      onSubmit={event => { event.preventDefault(); if (valid && !busy) onConfirm(inn, pin) }}>
      <h2 id={titleId}><ContactRound size={20} aria-hidden="true" />{tr('Смена ИНН оператора')}</h2>
      <p>{name}</p>
      <p>{tr('Текущий ИНН')}: <strong>{currentInn || '—'}</strong></p>
      <p className={s.muted}>{tr('После изменения оператор входит по новому ИНН. PIN и пароль сохраняются.')}</p>
      {error && <div className={s.error} role="alert">{tr(error)}</div>}
      <label className={s.field}>{tr('Новый ИНН')}<input required autoFocus inputMode="numeric" pattern="[0-9]{14}" maxLength={14}
        disabled={busy} value={inn} onChange={event => setInn(event.target.value.replace(/[^0-9]/g, '').slice(0, 14))} /></label>
      <p className={s.muted}>{tr('ИНН должен состоять из 14 цифр.')}</p>
      <ActorPinField value={pin} onChange={setPin} disabled={busy} hint="Введите PIN своей учётной записи. PIN оператора не подходит." />
      <div className={s.footer}>
        <button type="button" className={s.button} disabled={busy} onClick={onClose}><X size={14} aria-hidden="true" />{tr('Отмена')}</button>
        <button className={s.primary} disabled={busy || !valid}><Save size={14} aria-hidden="true" />{tr('Сохранить ИНН')}</button>
      </div>
    </form>
  </div>
}
